<div class="dialog" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header">
    <span>{{data.title}}</span>
    <span class="closeIcon cml-fw cml-lg cml-close" [attr.active-color]="'cml-active-black'" mat-dialog-close></span>
  </div>
  <div class="content">
    <mat-dialog-content>
      <div [formGroup]="form">
        <div *ngFor="let col of data.detail">

          <div *ngIf="col.type == 'string' || col.type == 'number'">
            <mat-form-field (mousedown)="$event.stopPropagation()" class="dialog-field">
              <mat-label>{{col.title}}</mat-label>
              <input matInput [formControlName]="col.name" [type]="col.type" (blur)="trimming(col.name,col.noTrimValue)">
              <mat-error>{{getErrorMessage(col.name)}}</mat-error>
            </mat-form-field>
          </div>

          <div *ngIf="col.type == 'password'">
            <mat-form-field (mousedown)="$event.stopPropagation()" class="dialog-field">
              <mat-label>{{col.title}}</mat-label>
              <input [type]="hidePassword[col.name] ? 'password' : 'text' " matInput [formControlName]="col.name">
              <mat-icon matSuffix  (click)="hidePassword[col.name] = !hidePassword[col.name]">
                <i [ngClass]="hidePassword[col.name] ? 'cml-fw cml-sm cml-eye' : 'cml-fw cml-sm cml-eye-slash' "></i>
              </mat-icon>
              <mat-error>{{getErrorMessage(col.name)}}</mat-error>
            </mat-form-field>
          </div>

          <cml-dropdown *ngIf="col.type === 'dropdown' && col.observable"
                        (mousedown)="$event.stopPropagation()"
                        [formControl]="$any(form.controls[col.name])"
                        [field]="col"
                        [errorMessage]="getErrorMessage(col.name)"
                        ngDefaultControl>
          </cml-dropdown>

          <mat-form-field *ngIf="col.type === 'boolean'"  class="dialog-field">
            <mat-label>{{col.title}}</mat-label>
            <mat-select matNativeControl [formControlName]="col.name">
              <mat-option *ngIf="!col.required" class="empty-option">nezadáno</mat-option>
              <mat-option [value]="true">Ano</mat-option>
              <mat-option [value]="false">Ne</mat-option>
            </mat-select>
            <mat-error>{{getErrorMessage(col.name)}}</mat-error>
          </mat-form-field>

          <div *ngIf="col.type == 'autocomplete'">
            <cml-autocomplete-control *ngIf="col.observable" (mousedown)="$event.stopPropagation()"
              [formControl]="$any(form.controls[col.name])" [field]="col" ngDefaultControl [errorMessage]="getErrorMessage(col.name)" ></cml-autocomplete-control>
          </div>

          <div *ngIf="col.type == 'extended_autocomplete'">
            <mat-form-field (mousedown)="$event.stopPropagation()" class="dialog-field">
              <mat-label>{{col.title}}</mat-label>
              <input type="text" [formControlName]="col.name" matInput [matAutocomplete]="auto">
              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                <mat-option *ngFor="let option of filteredOptions | async" [value]="option.kod">
                  {{option.kod}}
                </mat-option>
              </mat-autocomplete>
              <mat-error>{{getErrorMessage(col.name)}}</mat-error>
            </mat-form-field>
          </div>

          <div *ngIf="col.type === 'date'">
            <mat-form-field (mousedown)="$event.stopPropagation()" class="dialog-field">
              <mat-label>{{col.title}}</mat-label>
              <input matInput [formControlName]="col.name" [matDatepicker]="picker" >
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error>{{ getErrorMessage(col.name) }}</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div *ngIf="this.data.uploadFile" class="upload-container">
          <label>Přílohy:</label>
          <input type="file" class="upload" (change)="inputChange($event)" #fileInput />
          <div *ngIf="selectingFile || !file" class="dropable add-button" matTooltip="Připojit přílohu" matTooltipPosition="right" matTooltipShowDelay="1000" (drop)="drop($event)"
               (dragover)="allowDrop($event)" (dragleave)="leave()" id="dropzone" (click)="openFile()" #dropUpload>
            <i class="cml-fw cml-lg cml-plus"  [attr.active-color]="'cml-active-blue'"></i>
          </div>


          <div *ngIf="!selectingFile && file">
            {{file.name}} <i (click)="clearInput()" style="cursor:pointer;" class="cml-fw cml-lg cml-trash-o" active-color="cml-active-red"></i>
          </div>
        </div>

      </div>
    </mat-dialog-content>
    <div mat-dialog-actions class="dialog-actions">
      <button mat-button mat-dialog-close>Zavřít</button>
      <button mat-button (click)="save()" cdkFocusInitial>Potvrdit</button>
    </div>
  </div>
</div>
